import { Paper, Typography } from "@commonlibs";
import styled, { css } from "styled-components";

export const ActionsMenuPopoverPaper = styled(Paper)(
    ({ theme }) => css`
        padding: ${theme.spacing.all(3, 0)};
    `,
);

export const ActionMenuItem = styled(Typography)(
    ({ theme }) => css`
        padding: ${theme.spacing.all(2, 5)};
        cursor: pointer;
        &:hover {
            background-color: #efefef;
        }
    `,
);
